import { create } from 'zustand';

import { TipoContratoEnumChoice } from '@/shared';
import {
  getPaymentMethods,
  getPaymentMethodsProps,
} from '@/shared/actions/erp';
import { IPaymentMethod, IPaymentMethodDataRes } from '@/shared/interfaces/erp/system-settings';

interface PaymentMethodsState {
  isLoadingPaymentMethodsPaging: boolean;
  paymentMethodsPaging: IPaymentMethodDataRes;
  paymentMethodsFilterPaging: IPaymentMethod[];

  getPaymentMethods: (params?: getPaymentMethodsProps) => Promise<void>;
  getpaymentMethodsFilterPaging: (params?: getPaymentMethodsProps) => void;
  setIsLoading: (value: boolean) => void;
}

export const usePaymentMethodsStore = create<PaymentMethodsState>(set => ({
  paymentMethodsPaging: {
    count: 0,
    next: null,
    previous: null,
    numero_paginas: 0,
    data: [],
  },
  paymentMethodsFilterPaging: [],

  isLoadingPaymentMethodsPaging: false,

  getpaymentMethodsFilterPaging: async params => {
    set({ isLoadingPaymentMethodsPaging: true });
    const res = await getPaymentMethods(params);
    //FILTRAR FORMAS DE PAGO
    //const fp = filtroFormaPago(res.data.data);
    //const filter = concatenarNombres(fp);
    set({ paymentMethodsFilterPaging: res.data.data.filter(e => e.tipo_contrato != TipoContratoEnumChoice.ELINA_MOROCHO && e.estado), isLoadingPaymentMethodsPaging: false });
  },

  getPaymentMethods: async params => {
    set({ isLoadingPaymentMethodsPaging: true });

    const res = await getPaymentMethods(params);
    set({ paymentMethodsPaging: res.data, isLoadingPaymentMethodsPaging: false });
  },
  setIsLoading: value => set({ isLoadingPaymentMethodsPaging: value }),
}));


